import React from 'react';
import styled, { css } from 'styled-components';
import ButtonMicro from "./ButtonMicro";
import Cross from "../../Icon/Cross";
import Icon from "../../Icon/Icon";
import { REMOVE_BUTTON_TEST_ID } from "../constants";
import BinIcon from "../../Icon/Bin";
var StyledButton = styled(ButtonMicro).withConfig({
  displayName: "RemoveButton__StyledButton",
  componentId: "ap6bca-0"
})(["", ""], function (_ref) {
  var remove = _ref.theme.remove;
  return css(["background-color:", ";& ", "{fill:", ";}&:hover,&:focus{& ", "{fill:", ";}}&:active,&:hover,&:focus{background-color:", ";}"], remove.bgColor, Icon, remove.icon.defaultColor, Icon, remove.icon.activeColor, remove.activeBgColor);
});
var StyledKomusButton = styled(ButtonMicro).withConfig({
  displayName: "RemoveButton__StyledKomusButton",
  componentId: "ap6bca-1"
})(["", ""], function (_ref2) {
  var removeKomus = _ref2.theme.removeKomus;
  return css(["background-color:", ";& ", "{fill:", ";}&:hover,&:focus{& ", "{fill:", ";}}&:active,&:hover,&:focus{background-color:", ";}"], removeKomus.bgColor, Icon, removeKomus.icon.defaultColor, Icon, removeKomus.icon.activeColor, removeKomus.activeBgColor);
});

var RemoveButton = function RemoveButton(_ref3) {
  var onClick = _ref3.onClick,
      className = _ref3.className,
      isKomus = _ref3.isKomus;
  return React.createElement(React.Fragment, null, isKomus ? React.createElement(StyledKomusButton, {
    "data-testid": REMOVE_BUTTON_TEST_ID,
    className: className,
    onClick: onClick
  }, React.createElement(Cross, null)) : React.createElement(StyledButton, {
    "data-testid": REMOVE_BUTTON_TEST_ID,
    className: className,
    onClick: onClick
  }, React.createElement(Cross, null)));
};

export var IconRemoveButton = function IconRemoveButton(_ref4) {
  var onClick = _ref4.onClick,
      className = _ref4.className;
  return React.createElement(BinIcon, {
    onClick: onClick,
    className: className,
    "data-testid": REMOVE_BUTTON_TEST_ID
  });
};
export default RemoveButton;